import React from 'react';
import { Container } from 'reactstrap';

type Props = {
  children: JSX.Element | JSX.Element[];
};

export default ({ children }: Props) => {
  return (
    <React.Fragment>
      <Container className='mt--6' fluid>
        {children}
      </Container>
    </React.Fragment>
  );
};
